import {frameworkFlowManager} from "../../../core/components/flowManager/configuration/flowManagerConfiguration";


frameworkFlowManager.data = {

    "COMPONENTS": [
        {
            "id": "GameFlowManagerContainer",
            "name": "GameFlowManagerContainer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],

            child: [
                {
                    "id": "GameFlowManagerComponent",
                    "name": "GameFlowManager",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: []
                },
                {
                    "id": "MainSettingPanelComponent",
                    "name": "MainSettingPanelComponent",
                    "type": "Tag",
                    "class": "",
                    "parentLayer": "specialAnimationLayer",
                    "filterTypes": [],
                    child: []
                },

                {
                    "id": "MainSettingPanelPortraitComponent",
                    "name": "MainSettingPanelPortraitComponent",
                    "type": "Tag",
                    "class": "",
                    "parentLayer": "specialAnimationLayer",
                    "filterTypes": [],
                    child: []
                },
            ]
        }
    ]
}